import React from "react";
import { Head, Link } from "@inertiajs/react";

export default function Cgu() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Head title="Conditions Générales de Services" />

      <main className="flex-1">
        <div className="bg-[#015963] text-white py-16">
          <div className="container mx-auto px-4">
            <h1 className="text-3xl md:text-4xl font-bold">Conditions Générales de Services</h1>
            <p className="mt-2 text-white/90">En vigueur depuis le 22 mai 2025</p>
          </div>
        </div>

        <div className="container mx-auto px-4 py-10 prose prose-gray max-w-3xl">
          <p>
            JCF Santé (nom commercial : ETHOS SANTÉ), société par actions simplifiée, dont le siège social
            est situé au 15 rue du Père Roger Guichardan – 73000 Chambéry (la « Société ») exploite un site
            internet (accessible à l’adresse suivante : [à compléter], le « Site ») qui référence l’ensemble des
            masseurs-kinésithérapeutes exerçant en France (France métropolitaine et DROM-COM) (les
            « Masseurs-Kinésithérapeutes ») au sein d’un annuaire en ligne, à partir des données publiées sur le
            site de la Sécurité sociale et le site de l’Ordre des Masseurs-Kinésithérapeutes.
          </p>
          <p>
            Dans ce cadre, la Société fournit un service permettant aux Masseurs-Kinésithérapeutes de compléter
            les informations relatives à leur pratique médicale sur le Site. Les présentes conditions générales
            (« Conditions Générales ») s’appliquent ainsi à tout Masseur-Kinésithérapeute souhaitant bénéficier
            des services de la Société, tels que détaillés à l’article 3 ci-dessous.
          </p>

          <h2>Définitions</h2>
          <p>
            Les termes suivants commençant par une majuscule, qu’ils soient utilisés au singulier ou au pluriel,
            auront la signification définie ci-après, sans préjudice des termes définis dans le corps des Conditions
            Générales.
          </p>

          <h2>Nature des prestations</h2>
          <h3>La création d’un Profil Enrichi</h3>
          <p>
            Sous réserve de souscrire à la Prestation concernée et de payer le prix correspondant, la Société publiera
            l’ensemble des informations que le Masseur-Kinésithérapeute souhaite faire apparaître sur son Profil Enrichi.
            Dans un souci d’homogénéité du Site, la Société est autorisée à présenter ces informations dans le format qu’elle
            aura préalablement établi, sans que le Masseur-Kinésithérapeute et l’Utilisateur ne puissent imposer leurs choix.
          </p>

          <h3>La délivrance d’un Profil Vérifié</h3>
          <p>
            Sous réserve de souscrire à la Prestation concernée, de payer le prix correspondant et de réussir le questionnaire
            d’évaluation élaboré par un collège d’experts désignés par la Société (lequel sera composé de masseurs-kinésithérapeutes),
            le Masseur-Kinésithérapeute pourra solliciter la délivrance d’un Profil Vérifié auprès de la Société.
          </p>
          <ul>
            <li>
              le paiement du prix susvisé constitue la contrepartie du droit, pour le Masseur-Kinésithérapeute, de répondre au(x)
              questionnaire(s) d’évaluation sélectionné(s) et non pas de l’obtention du Profil Vérifié ; et
            </li>
            <li>
              la délivrance du Profil Vérifié ne constitue aucunement une certification professionnelle reconnue par une autorité
              publique, l’Ordre des Masseurs-Kinésithérapeutes ou tout autre organisme.
            </li>
          </ul>

          <h2>Obligations et garanties du partenaire</h2>
          <p>
            Tout au long de la durée du Contrat, le Masseur-Kinésithérapeute s’engage, notamment, à :
          </p>
          <ul>
            <li>
              fournir toute information ou document à la Société nécessaire et/ou utile à l’exécution de ses obligations au titre du Contrat,
              en particulier, toutes les informations nécessaires aux fins de la présentation du Profil Enrichi sur le Site ;
            </li>
            <li>
              coopérer activement avec la Société pour les besoins de la fourniture des Prestations ;
            </li>
            <li>
              se conformer aux Conditions Générales et aux Conditions Générales d’Utilisation du Site, accessibles ici.
            </li>
          </ul>
          <p>
            Pendant la durée du Contrat, le Masseur-Kinésithérapeute garantit que toutes les informations figurant au sein du Profil Enrichi sont
            constamment exactes, à jour, conformes aux Conditions Générales ainsi qu’à toutes les lois et règlementations qui lui sont applicables
            (notamment les obligations déontologiques issues du code de la santé publique). A ce titre, le Masseur-Kinésithérapeute s’engage, en tant que de besoin,
            à mettre à jour les informations figurant sur son Profil Enrichi depuis son compte extranet.
          </p>
          <p>
            La Société ne sera aucunement responsable des conséquences d’une information inexacte ou incomplète contenue au sein du Profil Enrichi. Ainsi, le Masseur-Kinésithérapeute garantit
            la Société contre toute réclamation d’un Utilisateur ou d’un tiers qui pourrait être formée à l’encontre de la Société concernant une information contenue au sein de son Profil Enrichi.
            Par ailleurs, la Société n’encourra aucune responsabilité dans la dispense, par les Masseurs-Kinésithérapeutes, de leurs actes médicaux vis-à-vis des Utilisateurs.
          </p>

          <h2>Conditions financières</h2>
          <p>
            Le prix des Prestations, y compris celui de chaque questionnaire d’évaluation, est détaillé sur le Site et sera intégralement facturé par la Société concomitamment à la souscription,
            par le Masseur-Kinésithérapeute, des Prestations et des questionnaires d’évaluation choisis. Toute participation à un questionnaire d’évaluation supplémentaire donnera lieu à une
            facturation additionnelle par la Société. Les sommes dues par le Masseur-Kinésithérapeute sont payables par carte bancaire via le prestataire de services de paiement Stripe Payments Europe Ltd.
            Le Masseur-Kinésithérapeute est invité à prendre connaissance des conditions générales éditées par ce prestataire.
          </p>

          <h2>Durée et résiliation du Contrat</h2>
          <h3>Durée</h3>
          <p>
            Chaque souscription de Prestations est conclue pour une durée initiale d’un (1) an. Au terme de cette durée, par dérogation à l’article 1214 du code civil, les Prestations se renouvelleront pour des périodes
            successives d’un (1) an sauf dénonciation par l’une des Parties adressée au moins un (1) mois avant l’expiration de la période en cours et par une lettre recommandée avec accusé de réception.
          </p>
          <h3>Résiliation</h3>
          <p>
            Chacune des Parties pourra résilier le Contrat, de plein droit et sans formalité judiciaire, par l’envoi d’une lettre recommandée avec accusé de réception, en cas de manquement de l’autre Partie à l’une de ses obligations
            auquel elle n’a pas remédié dans un délai de trente (30) jours calendaires suivant la réception d’une notification par lettre recommandée avec accusé de réception d’y remédier. Par exception à ce qui précède, la Société pourra résilier
            le Contrat immédiatement, de plein droit et sans formalité judiciaire, par l’envoi d’une lettre recommandée avec accusé de réception, notamment en cas de communication d’informations inexactes ou non-conformes à la règlementation et/ou
            de retrait de sa qualification professionnelle.
          </p>
          <p>
            En cas de cessation du Contrat, pour quelque raison que ce soit, le Profil Enrichi sera automatiquement converti en un Profil Standard et le cas échéant, le bénéfice de la délivrance du Profil Vérifié sera immédiatement retiré. Sauf dans l’hypothèse où la résiliation
            du Contrat résulterait d’un manquement de la Société, la résiliation du Contrat ne donnera lieu à aucun remboursement du prix payé par le Masseur-Kinésithérapeute.
          </p>

          <h3>Maintenance et support</h3>
          <p>
            Le Masseur-Kinésithérapeute est informé que la Société peut, à tout moment, initier des opérations de maintenance ou de mise à jour pouvant entrainer l’indisponibilité temporaire des Prestations et/ou du Site. Le Masseur-Kinésithérapeute dispose de la faculté de notifier les anomalies
            identifiées sur le Site à l’adresse suivante : contact@ethosante.fr. A réception, la Société s’efforcera de traiter la demande dans les meilleurs délais.
          </p>

          <h2>Données personnelles</h2>
          <p>
            Le Masseur-Kinésithérapeute est invité à consulter la politique de confidentialité de la Société, accessible ici, pour comprendre les conditions dans lesquelles la Société traite les données à caractère personnel que le Masseur-Kinésithérapeute soumet dans le cadre du Contrat.
          </p>

          <h2>Divers</h2>
          <h3>Indépendance des Parties</h3>
          <p>
            Les Parties ne pourront en aucun cas être considérées comme associées d’une entité commune quelconque. Aucune des Parties ne pourra, en outre, sauf mandat particulier, écrit, exprès et préalable de l’autre Partie, être considérée comme représentant de l’autre Partie, et ce à quelque titre et sous quelque modalité que ce soit.
          </p>
          <h3>Intuitu personae</h3>
          <p>
            La Société a accepté de conclure le Contrat avec le Masseur-Kinésithérapeute en raison de la personne de ce dernier. En conséquence, le Contrat ne pourra faire l’objet, de la part du Masseur-Kinésithérapeute, d’aucune cession des droits et obligations objets des présentes, totale ou partielle, sous quelque forme que ce soit, sans l’accord préalable et écrit de la Société.
          </p>
          <h3>Autonomie des stipulations</h3>
          <p>
            Si l’une quelconque des stipulations du Contrat devait être déclarée nulle au regard d’une règle de droit en vigueur ou d’une décision judiciaire devenue définitive, elle sera modifiée en vue d’obtenir sa validité ou sera réputée non écrite sans pour autant entraîner la nullité du Contrat, ni altérer la validité de ses autres stipulations.
          </p>
          <h3>Intégralité du Contrat</h3>
          <p>
            Le Contrat traduit l’ensemble des engagements des Parties dans le cadre de son objet. Il annule et remplace tous accords écrits et verbaux relativement à son objet, remis ou échangés antérieurement entre les Parties. Le Contrat ne peut être modifié que par un écrit signé par les Parties.
          </p>
          <h3>Non renonciation</h3>
          <p>
            Le fait que l’une ou l’autre des Parties ne revendique pas l’application de l’une quelconque des stipulations du Contrat ou accepte son inexécution, que ce soit de manière permanente ou temporaire, ne pourra pas être interprété et ne constituera pas une renonciation par cette Partie à son droit de faire appliquer ultérieurement cette stipulation ou toute autre stipulation du Contrat.
          </p>
          <h3>Confidentialité</h3>
          <p>
            Les informations de toute nature que chacune des Parties aura reçues de l’autre Partie et/ou auxquelles elle aura eu accès, directement ou indirectement, dans le cadre des Prestations sont confidentielles (les « Informations Confidentielles »). Chacune des Parties s’engage en conséquence à respecter la confidentialité la plus absolue vis-à-vis des Informations Confidentielles et notamment à ne pas transmettre ou donner accès à un tiers, à tout ou partie des Informations Confidentielles, et ce sous quelque forme que ce soit. Cet engagement de confidentialité demeurera en vigueur deux (2) ans après le terme du Contrat (quelle qu’en soit la cause).
          </p>

          <h2>Droit applicable et juridiction</h2>
          <p>
            Le Contrat est régi par le droit français. Tous litiges qui pourraient naître à l’occasion du Contrat, à raison de sa conclusion, de son interprétation, de son exécution ou de sa validité, seront de la compétence exclusive du tribunal de commerce de Chambéry, y compris en cas de référé, de demande incidente, de pluralité de défendeurs ou d’appel en garantie.
          </p>

          <div className="mt-8 text-sm text-gray-500">
            <p>
              Dernière mise à jour : 22 mai 2025
            </p>
          </div>

          <div className="mt-8">
            <Link href="/search" className="text-[#015963] hover:underline">
              Retour à la recherche
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}


